module.exports = __webpack_public_path__ + "img/13_K_spades.ca77a076.png";